import MainLayout from "@/components/layout/admin/MainLayout.vue";
import axios from "axios";
import CONFIG from "@/assets/js/config.js";
import {
  required,
  maxLength,
  minValue,
  requiredIf,
  maxValue,
} from "vuelidate/lib/validators";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: "LeaveTypeEdit",
  components: {
    MainLayout,
    Loading
  },

  data() {
    return {
      isLoading: false,
      disabled: false,
      leaveTypeData: {},
      leave_type: '',
      is_paid: null,
      total_day: null,
      description: '',
      submitted: false,
      methodExists: {},
      noDataMsg: CONFIG.NO_DATA_EXIST,
      STATUS: CONFIG.LEAVE_TYPE_STATUS,
      CONFIG,
    };
  },

  validations: {
    leave_type: {
      required,
      maxLength: maxLength(100)
    },
    description: {
      maxLength: maxLength(1000)
    },
    total_day: {
      required: requiredIf(function() {
        return Number(this.leaveTypeData.is_default) === CONFIG.LEAVE_TYPE_FLAG.IS_DEFAULT && 
          this.is_paid == this.STATUS.PAID;
      }),
      minValue: minValue(1),
      maxValue: maxValue(10000),
    }
  },

  watch: {
    leave_type() {
      if (this.methodExists.type) {
        this.methodExists.type = [];
      }
    }
  },

  methods: {
    getLeaveTypeEdit() {
      axios.get("/leaveType/detail/" + this.$route.params.id)
      .then(response => {
        this.leaveTypeData = response.data;
        if (this.leaveTypeData) {
          this.leave_type = this.leaveTypeData.type || '';
          this.description = this.leaveTypeData.description || '';
          this.is_paid = this.leaveTypeData.is_paid;
          this.total_day = this.leaveTypeData.total_day;
          this.is_default = this.leaveTypeData.is_default;
        }
        this.isLoading = false;
      }) .catch(error => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        if (error.response.status == 404) {
          this.$notification.error("Unauthorized or Leave Type Not Found", {
            timer: 3,
            position: "bottomCenter"
          });
          this.$router.push({ name: "leaveTypeList" });
        }
        this.isLoading = false;
        console.log("Leave Type Detail API Error", error);
      });
    },

    async confirmUpdate() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      if (this.is_paid === this.STATUS.NOT_PAID && this.total_day !== null && this.total_day !== "") {
        this.$notification.error("Total Days should not be assigned for Unpaid Leave.", {
          timer: 3,
          position: "bottomCenter"
        });
        this.disabled = false;
        return;
      }
      this.update();
    },

    update() {
      this.disabled = true;
      var id = this.$route.params.id
      var request = {
        type: this.leave_type,
        is_paid: this.is_paid,
        total_day: this.total_day,
        description: this.description,
        is_default: this.is_default,
      }
      axios.post("/leaveType/update/" + id, request, {
        headers: {
          'Content-Type': 'application/json',
        }
      }) .then(response => {
        if (response.data) {
          this.$notification.success("Leave Type Updated Successfully", {
            timer: 3,
            position: "bottomCenter"
          });
          this.$router.push({
            name: "leaveTypeList"
          });
        }
      }) .catch(error => {
        this.disabled = false;
        if (error.response?.status === 422) {
          this.methodExists = error.response.data.errors || {};
        } else if (error.response?.status === 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        } else {
          console.error("Unexpected error:", error);
        }
      });
    },

    showList() {
      this.$router.push({
        path: "/leaveType/list"
      });
    },

    handlePaidChange() {
      if (!this.is_paid) {
        this.total_day = null;
        if (this.$v.total_day) {
          this.$v.total_day.$reset();
        }
      }
    },

    filterTotalDay(event) {
      let value = event.target.value;

      value = value.replace(/[^0-9]/g, '');
      value = value.replace(/^0+/, '');

      this.total_day = value ? parseInt(value) : null;
    },
  },

  mounted() {
    this.isLoading = true;
    this.getLeaveTypeEdit();
  },
};
